import React from "react";
import CPF from "../../../components/Formatters/CPF";
import CNPJ from "../../../components/Formatters/CNPJ";
import IE from "../../../components/Formatters/IE";
import Id from "../../../components/Formatters/Id";

const ExemploFormatters = () => (
  <div style={{ backgroundColor: "white", padding: "20px" }}>
    <h1>Exemplo usando Formatters</h1>
    <br />
    CPF:
    <CPF value="01358267780" />
    | (vazio):
    <CPF value={null} empty="Não informado" />
    | (formato inválido):
    <CPF value="0111" warn />
    | (ID)
    <Id value="01358267780" />
    <br />
    CNPJ:
    <CNPJ value="01195196000164" />
    | (ID)
    <Id value="01195196000164" />
    <br />
    IE:
    <IE value="203651234" />
    |
    <Id value="204445554" />
    <br />
  </div>
);

export default ExemploFormatters;
